import { render } from "./FichaRegistroAcelerometrico.vue?vue&type=template&id=50efa7ae"
import script from "./FichaRegistroAcelerometrico.vue?vue&type=script&lang=js"
export * from "./FichaRegistroAcelerometrico.vue?vue&type=script&lang=js"

import "./FichaRegistroAcelerometrico.vue?vue&type=style&index=0&id=50efa7ae&style=scoped&lang=scss"

import exportComponent from "/opt/web_acelerometrica_publica/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__